module.exports = __webpack_public_path__ + "assets/img/Amaze-Wholesale-2-Landing-Page-w720.48e5af27.webp";